import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Settlement from 'features/settlement/Settlement'
import Layout from 'components/layout/Layout'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import { useTranslation } from 'next-i18next/pages'
import type { SeoProps } from 'components/seo/types'

const SettlementPage = () => {
  // i18n
  const { t } = useTranslation('settlement')

  // Constants
  const SEO: SeoProps = {
    title: t('seoTitle')
  }

  return (
    <Layout seo={SEO}>
      <Settlement />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'settlement', 'faqIncreaseInstallment'], i18nConfig))
    }
  }
}

export default SettlementPage
